import { StyleSheet } from "react-native";
import { theme } from "@clearabee/ui-library-native";

export const trainStyles = StyleSheet.create({
  openButton: {
    transform: [{ rotate: "90deg" }],
  },
  closeButton: {
    transform: [{ rotate: "270deg" }],
  },
  trainPanel: {
    paddingVertical: theme.spacing.xsmall,
    position: "relative",
  },
  trainOpenCloseButton: {
    position: "absolute",
    top: 14,
    right: theme.spacing.small,
  },
});

export const horizontalStyles = StyleSheet.create({
  heading: {
    textAlign: "center",
    marginTop: theme.spacing.xsmall,
  },
  description: {
    textAlign: "center",
    marginTop: theme.spacing.small,
  },
  gradientWrapper: {
    position: "absolute",
    height: "100%",
    width: "100%",
    justifyContent: "center",
  },
  gradient: {
    width: "100%",
    height: 5,
  },
});

export const verticalStyles = StyleSheet.create({
  wrapper: {
    flexDirection: "row",
  },
  innerWrapper: {
    width: "100%",
    alignItems: "center",
  },
  lineWrapper: {
    minHeight: theme.spacing.large,
    overflow: "hidden",
    backgroundColor: theme.colors.greyscale.lightest,
  },
  contentWrapper: {
    justifyContent: "center",
    marginLeft: theme.spacing.small,
    flex: 1,
  },
  description: {
    marginTop: theme.spacing.xsmall2,
    flexShrink: 1,
    flex: 1,
  },
});
